/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g of glucose in 100 mL: %(w/v) = 5 / 100 × 100 = 5%.`)
};

const es_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g de glucosa en 100 mL: %(p/v) = 5 / 100 × 100 = 5%.`)
};

const de_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g Glucose in 100 mL: %(w/v) = 5 / 100 × 100 = 5%.`)
};

const nl_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g glucose in 100 mL: %(g/v) = 5 / 100 × 100 = 5%.`)
};

const fr_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g de glucose dans 100 mL : %(p/v) = 5 / 100 × 100 = 5 %.`)
};

const it_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g di glucosio in 100 mL: %(p/v) = 5 / 100 × 100 = 5%.`)
};

const pt_br2_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g de glicose em 100 mL: %(p/v) = 5 / 100 × 100 = 5%.`)
};

const pt_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 g de glucose em 100 mL: %(m/v) = 5 / 100 × 100 = 5%.`)
};

const ja_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グルコース5 gを100 mLに: %(w/v) = 5 / 100 × 100 = 5%。`)
};

const zh_pctsol_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 mL 中含 5 g 葡萄糖：%(w/v) = 5 / 100 × 100 = 5%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_ex1", locale)
	if (locale === "en") return en_pctsol_ex1(inputs)
	if (locale === "es") return es_pctsol_ex1(inputs)
	if (locale === "de") return de_pctsol_ex1(inputs)
	if (locale === "nl") return nl_pctsol_ex1(inputs)
	if (locale === "fr") return fr_pctsol_ex1(inputs)
	if (locale === "it") return it_pctsol_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_ex1(inputs)
	if (locale === "pt") return pt_pctsol_ex1(inputs)
	if (locale === "ja") return ja_pctsol_ex1(inputs)
	return zh_pctsol_ex1(inputs)
};